import { api } from 'app/utils/api/helpers'

export const adminResendAgencyUserInvitation = (invitationID: string) => {
  return api.post(`/admin/agencies/invite/${invitationID}/resend`)
}
